var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 4C3.355 4 2 5.355 2 7v10c0 1.645 1.355 3 3 3h14c1.645 0 3-1.355 3-3V7c0-1.645-1.355-3-3-3zm.615 2h12.756l-6.092 5.88a.46.46 0 0 1-.605 0zM20 7.207V17c0 .571-.429 1-1 1H5c-.571 0-1-.429-1-1V7.22l6.281 6.096a2.44 2.44 0 0 0 3.387.004z"
  })));
};
export default SvgEmail;